import { FilterLink } from '../ThirdPane';
import { constantToLabel } from '@ecosconnect/core/src/helpers/string';
import React from 'react';
import { Box, BoxProps, Flex, FlexProps } from 'rebass';

type JobHistoryTypePickerProps<T extends string> = BoxProps & {
  availableTypes: T[];
  selectedTypes?: T[];
  onSelectionChange: (selectedTypes: T[]) => void;
};

const HistoryTypePicker = <T extends string>({
  selectedTypes = [],
  onSelectionChange,
  availableTypes,
  ...props
}: JobHistoryTypePickerProps<T>) => {
  return (
    <Box flexShrink={0} flexGrow={0} {...(props as any)}>
      <FilterLink
        active={availableTypes.every((x) => selectedTypes.includes(x))}
        onClick={() => onSelectionChange(availableTypes)}
      >
        All
      </FilterLink>
      {availableTypes.map((historyType, i) => {
        return (
          <FilterLink
            key={i}
            active={
              selectedTypes.includes(historyType) && selectedTypes.length === 1
            }
            onClick={() => onSelectionChange([historyType])}
          >
            {constantToLabel(historyType)}
          </FilterLink>
        );
      })}
    </Box>
  );
};

export default HistoryTypePicker;
